import { timeToSec } from '../utilities/DateTimeUtils';
import { IsListEmpty } from './CommonMethods';

const sortByMostRecent = (currentTab, results) => {
    let updatedList = [];
    switch (currentTab) {
        case 1:
            const updatedCourseResults = results;
            updatedList = updatedCourseResults.courses;
            updatedList = updatedList.sort(function (a, b) {
                return new Date(b.updated_date).getTime() - new Date(a.updated_date).getTime();
            });
            updatedCourseResults.courses = updatedList;
            return updatedCourseResults;
        case 2:
            const updatedLVResults = results;
            updatedList = updatedLVResults.learningVideos;
            updatedList = updatedList.sort(function (a, b) {
                return new Date(b.uploadedDate).getTime() - new Date(a.uploadedDate).getTime();
            });
            updatedLVResults.learningVideos = updatedList;
            return updatedLVResults;
        case 3:
            const updatedTBResults = results;
            updatedList = updatedTBResults.techbytes;
            updatedList = updatedList.sort(function (a, b) {
                return new Date(b.uploadedDate).getTime() - new Date(a.uploadedDate).getTime();
            });
            updatedTBResults.techbytes = updatedList;
            return updatedTBResults;
        default:
    }
}

const sortByMostView = (currentTab, results) => {
    let updatedList = [];
    switch (currentTab) {
        case 1:
            const updatedCourseResults = results;
            updatedList = updatedCourseResults.courses;
            updatedList = updatedList.sort(function (a, b) {
                return b.views - a.views;
            });
            updatedCourseResults.courses = updatedList;
            return updatedCourseResults;
        case 2:
            const updatedLVResults = results;
            updatedList = updatedLVResults.learningVideos;
            updatedList = updatedList.sort(function (a, b) {
                return b.views - a.views;
            });
            updatedLVResults.learningVideos = updatedList;
            return updatedLVResults;
        case 3:
            const updatedTBResults = results;
            updatedList = updatedTBResults.techbytes;
            updatedList = updatedList.sort(function (a, b) {
                return b.views - a.views;
            });
            updatedTBResults.techbytes = updatedList;
            return updatedTBResults;
        default:
    }
}

const sortByMostLikes = (currentTab, results) => {
    let updatedList = [];
    switch (currentTab) {
        case 1:
            const updatedCourseResults = results;
            updatedList = updatedCourseResults.courses;
            updatedList = updatedList.sort(function (a, b) {
                return b.likes - a.likes;
            });
            updatedCourseResults.courses = updatedList;
            return updatedCourseResults;
        case 2:
            const updatedLVResults = results;
            updatedList = updatedLVResults.learningVideos;
            updatedList = updatedList.sort(function (a, b) {
                return b.likes - a.likes;
            });
            updatedLVResults.learningVideos = updatedList;
            return updatedLVResults;
        case 3:
            const updatedTBResults = results;
            updatedList = updatedTBResults.techbytes;
            updatedList = updatedList.sort(function (a, b) {
                return b.likes - a.likes;
            });
            updatedTBResults.techbytes = updatedList;
            return updatedTBResults;
        default:
    }
}

const sortByHighestDuration = (currentTab, results) => {
    let updatedList = [];
    switch (currentTab) {
        case 1:
            const updatedCourseResults = results;
            updatedList = updatedCourseResults.courses;
            updatedList = updatedList.sort(function (a, b) {
                return timeToSec(b.duration) - timeToSec(a.duration);
            });
            updatedCourseResults.courses = updatedList;
            return updatedCourseResults;
        case 2:
            const updatedLVResults = results;
            updatedList = updatedLVResults.learningVideos;
            updatedList = updatedList.sort(function (a, b) {
                return parseInt(b.duration, 10) - parseInt(a.duration, 10);
            });
            updatedLVResults.learningVideos = updatedList;
            return updatedLVResults;
        case 3:
            const updatedTBResults = results;
            updatedList = updatedTBResults.techbytes;
            updatedList = updatedList.sort(function (a, b) {
                return parseInt(b.duration, 10) - parseInt(a.duration, 10);
            });
            updatedTBResults.techbytes = updatedList;
            return updatedTBResults;
        default:
    }
}

const sortVideoByMostRecent = (videoList) => {
    const updatedList = videoList.sort(function (a, b) {
        return new Date(b.uploadedDate).getTime() - new Date(a.uploadedDate).getTime();
    });
    return updatedList;
}

const sortVideoByMostLikes = (videoList) => {
    const updatedList = videoList.sort(function (a, b) {
        return b.likes - a.likes;
    });
    return updatedList;
}

const sortVideoByMostViews = (videoList) => {
    const updatedList = videoList.sort(function (a, b) {
        return b.views - a.views;
    });
    return updatedList;
}

const sortCourseByMostRecent = (courseList) => {
    const updatedList = courseList.sort(function (a, b) {
        return new Date(b.updated_date).getTime() - new Date(a.updated_date).getTime()
    });
    return updatedList;
}

const sortCourseByDuration = (courseList) => {
    const updatedList = courseList.sort(function (a, b) {
        return b.duration - a.duration;
    });
    return updatedList;
}

const sortCourseByMostLikes = (courseList) => {
    const updatedList = courseList.sort(function (a, b) {
        return b.likes - a.likes;
    });
    return updatedList;
}

const sortTopicRequestsByMostRecent = (topicList) => {
    const updatedList = topicList.sort(function (a, b) {
        return new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()
    });
    return updatedList;
}

const sortTopicRequestsByMostUpvotes = (topicList) => {
    const updatedList = topicList.sort(function (a, b) {
        return b.upvotedCount - a.upvotedCount;
    });
    return updatedList;
}

const sortWorkExperienceByMostRecent = (list) => {
    if (IsListEmpty(list)) return [];

    const updatedList = list.sort(function (a, b) {
        return new Date(b.startDate).getTime() - new Date(a.startDate).getTime()
    });
    return updatedList;
}

const sortProjectsByMostRecent = (list) => {
    if (IsListEmpty(list)) return [];

    const updatedList = list.sort(function (a, b) {
        return new Date(b.projectStartDate).getTime() - new Date(a.projectStartDate).getTime()
    });
    return updatedList;
}

const sortEducationByMostRecent = (list) => {
    if (IsListEmpty(list)) return [];

    const updatedList = list.sort(function (a, b) {
        return b.yearOfCompletion - a.yearOfCompletion
    });
    return updatedList;
}

const sortLearningScheduleByStartTime = (list) => {
    if (IsListEmpty(list)) return [];

    const updatedList = list.sort(function (a, b) {
        return new Date(a.date + ' ' + a.startTime).getTime() - new Date(b.date + ' ' + b.startTime).getTime();
    });
    return updatedList;
}

const sortNotificationsByMostRecent = (list) => {
    if (IsListEmpty(list)) return [];

    const updatedList = list.sort(function (a, b) {
        return new Date(b.dateTime).getTime() - new Date(a.dateTime).getTime()
    });
    return updatedList;
}

const sortProgramCardsNewest = (list) => {
    if (IsListEmpty(list)) return [];

    const updatedList = list.sort(function (a, b) {
        return new Date(b.date).getTime() - new Date(a.date).getTime()
    });
    return updatedList;
}

const sortProgramCardsOldest = (list) => {
    if (IsListEmpty(list)) return [];

    const updatedList = list.sort(function (a, b) {
        return new Date(a.date).getTime() - new Date(b.date).getTime()
    });

    return updatedList;
}
const sortStudentsByName = (list, type) => {
    if (IsListEmpty(list)) return [];

    let updatedList = [];
    if (type === 'ascending') {
        updatedList = list.sort(function (a, b) {
            let aName = a.name ? a.name : a.studentName ? a.studentName : ''
            let bName = b.name ? b.name : b.studentName ? b.studentName : ''
            if (aName.toLowerCase() < bName.toLowerCase()) { return -1; }
            else if (aName.toLowerCase() > bName.toLowerCase()) { return 1; }
            return aName.toLowerCase() < bName.toLowerCase();
        });
    } else if (type === 'descending') {
        updatedList = list.sort(function (a, b) {

            let aName = a.name ? a.name : a.studentName ? a.studentName : ''
            let bName = b.name ? b.name : b.studentName ? b.studentName : ''
            if (aName.toLowerCase() < bName.toLowerCase()) { return 1; }
            else if (aName.toLowerCase() > bName.toLowerCase()) { return -1; }
            return aName.toLowerCase() < bName.toLowerCase();
        });
    }
    return updatedList;
}

const sortStudentsByStatus = (list, type) => {
    if (IsListEmpty(list)) return [];

    let updatedList = [];
    if (type === 'ascending') {
        updatedList = list.sort(function (a, b) {
            if (a.status.toLowerCase() < b.status.toLowerCase()) { return -1; }
            else if (a.status.toLowerCase() > b.status.toLowerCase()) { return 1; }
            return a.status.toLowerCase() < b.status.toLowerCase();
        });
    } else if (type === 'descending') {
        updatedList = list.sort(function (a, b) {
            if (a.status.toLowerCase() < b.status.toLowerCase()) { return 1; }
            else if (a.status.toLowerCase() > b.status.toLowerCase()) { return -1; }
            return a.status.toLowerCase() < b.status.toLowerCase();
        });
    }
    return updatedList;
}

const sortLIVESessionsByDate = (data) => {
    const updatedData = data;
    const updatedList = updatedData.sort(function (a, b) {
        if (new Date(a.schedule_time) < new Date(b.schedule_time)) { return -1; }
        else if (new Date(a.schedule_time) > new Date(b.schedule_time)) { return 1; }
        return new Date(a.schedule_time) < new Date(b.schedule_time);
    });
    return updatedList;
}
const sortLIVESessionsByInstructorName = (data) => {
    const updatedData = data;
    const updatedList = updatedData.sort(function (a, b) {
        if (a.instructor_name.toLowerCase() < b.instructor_name.toLowerCase()) { return -1; }
        else if (a.instructor_name.toLowerCase() > b.instructor_name.toLowerCase()) { return 1; }
        return a.instructor_name.toLowerCase() < b.instructor_name.toLowerCase();
    });
    return updatedList;
}

const sortEnrolledModulesByMostRecent = (list) => {
    if (IsListEmpty(list)) return [];

    const updatedList = list.sort(function (a, b) {
        return new Date(b.startDate) - new Date(a.startDate)
    });
    return updatedList;
}

const sortInstructorListByName = (list) => {
    if (IsListEmpty(list)) return [];

    let updatedList = [];
    updatedList = list.sort(function (a, b) {
        if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
        else if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
        return a.name.toLowerCase() < b.name.toLowerCase();
    });
    return updatedList;
}

const sortProgramListByBatchCode = (list) => {
    if (IsListEmpty(list)) return [];

    let updatedList = [];
    updatedList = list.sort(function (a, b) {
        if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
        else if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
        return a.name.toLowerCase() < b.name.toLowerCase();
    });
    return updatedList;
}


const SortHelper = {
    sortByMostRecent, sortByMostLikes, sortByMostView, sortByHighestDuration, sortVideoByMostRecent, sortVideoByMostLikes,
    sortVideoByMostViews, sortCourseByMostRecent, sortCourseByDuration, sortCourseByMostLikes, sortTopicRequestsByMostRecent,
    sortTopicRequestsByMostUpvotes, sortWorkExperienceByMostRecent, sortProjectsByMostRecent, sortEducationByMostRecent,
    sortLearningScheduleByStartTime, sortNotificationsByMostRecent, sortProgramCardsNewest, sortProgramCardsOldest, sortStudentsByName,
    sortStudentsByStatus, sortLIVESessionsByDate, sortEnrolledModulesByMostRecent, sortInstructorListByName, sortProgramListByBatchCode, sortLIVESessionsByInstructorName
};

export default SortHelper;